import { IconButton, Menu } from '@mui/material';
import { getSelectorAttribute, usagePageSelectors } from '@vy/app-selectors';
import { useMenu } from '../../../../../hooks/use-menu';
import { DeleteMeasurementDialog } from './DeleteMeasurementDialog';
import { EditMeasurementDialog } from './EditMeasurementDialog';

type MeasurementDotMenuProps = {
  currentUnits: number;
  measurementId: string;
};

export const MeasurementDotMenu: React.FC<MeasurementDotMenuProps> = ({ measurementId, currentUnits }) => {
  const { isOpen, handleMenuOpen, handleMenuClose, anchorElement } = useMenu();

  return (
    <>
      <IconButton
        {...getSelectorAttribute(usagePageSelectors.measurementsTable.dotsMenu.dotsMenuButton)}
        onClick={handleMenuOpen}
        className="aspect-square rounded-full"
      >
        <span className="bg-icon text-label mx-2 mb-[3px] inline-block h-1 w-1 rounded-full shadow-[0_7px_0_#ADC2E2,0_-7px_0_#ADC2E2]"></span>
      </IconButton>

      <Menu
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={isOpen}
        anchorEl={anchorElement}
        onClose={handleMenuClose}
        slotProps={{
          paper: {
            className: 'max-w-[200px] w-full rounded-lg',
          },
        }}
      >
        <EditMeasurementDialog currentValue={currentUnits} measurementId={measurementId} />

        <DeleteMeasurementDialog measurementId={measurementId} />
      </Menu>
    </>
  );
};
